import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, CategoryDto } from '../models/product.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CategoryService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Categories`;

  getAll(
    search?: string,
    includeAttributes = false,
    storeTypeId?: string | null,
  ): Observable<ApiResponse<CategoryDto[]>> {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    if (includeAttributes) params = params.set('includeAttributes', 'true');
    if (storeTypeId) params = params.set('storeTypeId', storeTypeId);
    return this.http.get<ApiResponse<CategoryDto[]>>(this.endpoint, { params });
  }

  create(name: string, storeTypeId?: string | null): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.endpoint, {
      name,
      storeTypeId: storeTypeId ?? null,
    });
  }

  update(id: string, name: string, isActive: boolean): Observable<ApiResponse<unknown>> {
    return this.http.put<ApiResponse<unknown>>(`${this.endpoint}/${id}`, { id, name, isActive });
  }

  delete(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.endpoint}/${id}`);
  }
}
